import { Search } from 'js-search'
import { useStaticQuery, graphql } from 'gatsby'
import { useCallback, useMemo, useState } from 'react'

interface Node {
  excerpt: string
  id: string
  frontmatter: {
    title: string
  }
  fields: {
    slug: string
  }
  html: string
}

type SearchData = {
  id: string
  title: string
  excerpt: string
  slug: string
  content: string
}

export const useQueryPost = (keywordProps?: string) => {
  const { allMarkdownRemark } = useStaticQuery(graphql`
    query SearchQuery {
      allMarkdownRemark(sort: { frontmatter: { date: DESC } }) {
        edges {
          node {
            excerpt(pruneLength: 280, truncate: true)
            id
            frontmatter {
              title
            }
            fields {
              slug
            }
            html
          }
        }
      }
    }
  `)

  const jsSearch = useMemo(() => {
    const search = new Search('id')
    const documents = allMarkdownRemark.edges.map(({ node }: { node: Node }) => ({
      id: node.id,
      title: node.frontmatter.title,
      excerpt: node.excerpt,
      slug: node.fields.slug,
      content: node.html.replace(/(<([^>]+)>)/gi, ''), // Remove HTML tags from content
    }))

    search.addIndex('title')
    search.addIndex('excerpt')
    search.addIndex('content')
    search.addDocuments(documents)

    return search
  }, [allMarkdownRemark.edges])

  const [keyword, setKeyword] = useState<string>(keywordProps ?? '')
  const [searchResult, setSearchResult] = useState<Array<SearchData>>([])

  const handleChangeKeyword = useCallback(
    (value: string) => {
      setKeyword(value)
      if (value) {
        // TODO: 한글 검색 안되는 문제 해결
        const result = jsSearch.search(value) as SearchData[]
        setSearchResult(result ?? [])
        return
      }
      setSearchResult([])
    },
    [jsSearch],
  )

  return { search: keyword, onChange: handleChangeKeyword, data: searchResult }
}
